import { useMemo } from "react";
import { z } from "zod";

const EnvSchema = z.object({
  MODE: z.string(),
  VITE_HASURA_URL: z.string(),
  VITE_AUTH0_DOMAIN: z.string(),
  // Default tenant hostname (*.auth0.com), used for Auth0 API audiences.
  VITE_AUTH0_DEFAULT_TENANT_DOMAIN: z.string().optional(),
  VITE_AUTH0_CLIENT_ID: z.string(),
  VITE_FORM_SERVICE_BASE_URL: z.string(),
  VITE_WEGLOT_APIKEY: z.string(),
  VITE_AVELA_OFFLINE_AUTH_TOKEN: z.string().optional(),
  VITE_GOOGLE_API_KEY: z.string().optional(),
  VITE_GOOGLE_SERVICE_ACCOUNT: z
    .string()
    .default("avela-ide-translation@avela-explore.iam.gserviceaccount.com"),
  VITE_MATCH_API_URL: z.string().optional(),
  VITE_FLAGSMITH_URL: z.string(),
  VITE_FLAGSMITH_ENVIRONMENT_KEY: z.string(),
  VITE_ASSETS_BASE_URL: z.string(),
  VITE_CONFIG_URL: z.string(),
  VITE_ELIGIBILITY_SERVICE_URL: z.string(),
  VITE_EXPLORE_SERVICE_URL: z.string(),
  VITE_AVELA_SERVICES_BASE_URL: z.string(),
  VITE_AVELA_STRIPE_OAUTH_CLIENT_ID: z.string(),
});

export type Env = z.infer<typeof EnvSchema>;

export function read(): Env {
  return EnvSchema.parse(import.meta.env);
}

export function useEnv() {
  return useMemo(() => read(), []);
}
